// extracted by mini-css-extract-plugin
export var firstP = "SocialNetwork-module--first-p---Zm7P";
export var image = "SocialNetwork-module--image--eo+JG";
export var imageWrapper = "SocialNetwork-module--image-wrapper--XX-U1";
export var link = "SocialNetwork-module--link--5qIT-";
export var roots = "SocialNetwork-module--roots--vuahk";
export var secondP = "SocialNetwork-module--second-p---63p3";
export var textWrapper = "SocialNetwork-module--text-wrapper--TGBYh";